import React, {Component} from 'react';
import Cookies from 'universal-cookie';

import * as Message from "../../components/shared/Message"
import {Eye} from 'react-bootstrap-icons';
import * as formValidacao from '../../commons/functions/form-validacao.js';
import './styles.css';
import {Link, withRouter} from "react-router-dom";
import Version from "../../components/Version/Version";
import {inicializaUsuarioDD} from "../../utils/inicializaUsuarioDD";
import * as _authService from "../../service/auth-service";
import InputMask from "../../components/Input/InputMask";
import {Box} from "@material-ui/core";
import Clarity from "@microsoft/clarity";
import {getRecoil, setRecoil} from "recoil-nexus";
import {claritySessionState} from "../../recoil/atoms/claritySessionState";
import {v4} from "uuid";
import {PATH_ROUTE} from "../../routes";
import {accessTokenState} from "../../recoil/atoms/accessTokenState";
import {persistor, store} from "../../configureStore";
import {logout} from "../../modules/Login/actions";
import {useSetRecoilState} from "recoil";
import {sidebarOpenedMenuItemState} from "../../recoil/atoms/sidebarOpenedMenuItemState";
import {sidebarSelectedMenuItemState} from "../../recoil/atoms/sidebarSelectedMenuItemState";
import {sidebarHiddenMenusState} from "../../recoil/atoms/sidebarHiddenMenusState";
import {unidadeGetResponseState} from "../../recoil/atoms/unidadeGetResponseState";
import {matriculasByResponsavelResponseState} from "../../recoil/atoms/matriculasByResponsavelResponseState";

class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.btnclick = this.btnclick.bind(this);
    this.state = {
      item: {},
      error: false,
      isLoaded: true,
      errors: {},
      manterDados: false,
      needChallenge: false,
      mensagem: false,
      type: "password",
      cpf: '',
      senha: ''
    };
    this.cookies = new Cookies();
  }

  async componentDidMount() {
    const mensagem = this.GetParameterByName(window.location.href, "mensagem");
    const mensagemCriada = this.GetParameterByName(window.location.href, "mensagemCriada");
    const mensagemError = this.GetParameterByName(window.location.href, "mensagemError");
    if (mensagem) {
      Message.ExibeMensagem("Acabamos de te enviar um link para redefinição de senha, verifique seu e - mail.", "0", true);
    } else if (mensagemCriada) {
      Message.ExibeMensagem("Agora é só fazer seu login e começar a matricula!", "0", true);
    } else if (mensagemError) {
      Message.ExibeMensagem("Sua senha já foi definida. Caso tenha esquecido, clique abaixo em Esqueci minha senha para redefinir.", "2", false);
    }

    await this.Logado();

    const contactInfo = document.getElementById("contact-info");
    if (contactInfo != null) {
      contactInfo.style.display = "none";
    }

    const drozDiv = document.getElementById("droz-div");
    if (drozDiv != null) {
      drozDiv.style.display = "none";
    }
  }

  HandleSenhaBtn(e) {
    if (this.state.type == "text") {
      this.setState({type: "password"});
    } else {
      this.setState({type: "text"});
    }

  }

  GetParameterByName(pageLocation, name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(pageLocation);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  async Logado() {
    let id = this.cookies.get("@SMO20/idResponsavel");
    let username = this.cookies.get("@SMO20/nomeResponsavel");
    let cpf = this.cookies.get("@SMO20/cpfResponsavel");
    let senha = this.cookies.get("@SMO20/senhaResponsavel");
    let manterDados = this.cookies.get("@SMO20/btnManterDados");
    let token = getRecoil(accessTokenState);

    if (id && username) {
      sessionStorage.setItem('@SMO20/idResponsavel', id);
      sessionStorage.setItem('@SMO20/nomeResponsavel', username);
      this.setState({
        isLoaded: true,
        redirecionar: true
      });
    }
    if (manterDados) {
      this.setState({cpf: cpf, senha: senha, manterDados: true});
    }

    if (token && token.length > 0) {
      this.cookies.remove("@SMO20/idResponsavel");
      this.cookies.remove("@SMO20/nomeResponsavel");

      setRecoil(sidebarOpenedMenuItemState, []);
      setRecoil(sidebarSelectedMenuItemState, null);
      setRecoil(sidebarHiddenMenusState, []);
      setRecoil(accessTokenState, '');
      setRecoil(unidadeGetResponseState, null);
      setRecoil(matriculasByResponsavelResponseState, null);

      sessionStorage.clear();
      localStorage.clear();

      await persistor.purge();
    }
  }

  async handleCheck(e) {
    const date = new Date();
    date.setDate(date.getDate() + 3);

    if (e.target.checked) {
      this.setState({manterDados: true});
      await this.cookies.set('@SMO20/btnManterDados', true, {path: '/', expires: date});
    } else {
      this.setState({manterDados: false});
      await this.cookies.remove('@SMO20/btnManterDados');
      await this.cookies.remove('@SMO20/cpfResponsavel');
      await this.cookies.remove('@SMO20/senhaResponsavel');
    }
  }

  formValidation() {
    const cpf = this.state.cpf;
    const senha = this.state.senha;

    let errors = {};
    let formIsValid = true;

    if (this.state.needChallenge && 'grecaptcha' in window) {
      var response = window.grecaptcha.getResponse();
      if (!response) {
        formIsValid = false;
        errors["_captcha"] = "Por favor, resolva o captcha.";
      } else {
        errors["_captcha"] = undefined;
      }
    }

    if (!formValidacao.isValidCPF(cpf)) {
      formIsValid = false;
      errors["_cpf"] = "Por favor digite seu CPF.";
    } else {
      errors["_cpf"] = undefined;
    }

    if (!formValidacao.isValidSenha(senha)) {
      formIsValid = false;
      errors["_senha"] = "Por favor digite sua senha.";
    } else {
      errors["_senha"] = undefined;
    }

    if (formIsValid) {
      this.setState({error: false, isLoaded: false, errors: errors});
    } else {
      this.setState({error: true, isLoaded: true, errors: errors});
    }
    return formIsValid;
  }

  change(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  btnclick(event) {
    event.preventDefault()
    if (this.formValidation()) {
      try {
        const obj = {
          'username': this.state.cpf,
          'password': this.state.senha,
        };

        if (this.state.needChallenge && 'grecaptcha' in window) {
          obj.captcha = window.grecaptcha.getResponse();
        }

        this.postlogin(obj);
      } catch (error) {
        console.log("catch do btnClick " + error);
        this.setState({error: false, isLoaded: true,});
      }

      this.setState({
        isLoaded: false
      });
    }
  }

  async postlogin(obj) {
    try {
      await _authService.login(obj)
        .then(
          async (result) => {
            if (result.needChallenge && 'grecaptcha' in window) {
              window.grecaptcha.render('recaptcha', {
                sitekey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
              });

              this.setState({
                isLoaded: true,
                needChallenge: true,
                senha: '',
                error: "Login ou senha inválidos"
              });

              return;
            }

            sessionStorage.setItem('@SMO20/cadastroPendente', result.cadastropendente);
            sessionStorage.setItem('@SMO20/idResponsavel', result.id);
            sessionStorage.setItem('@SMO20/nomeResponsavel', result.username);
            sessionStorage.setItem('@SMO20/cpf', this.state.cpf);

            if (process.env.REACT_APP_CLARITY_ENABLED === 'true') {
              const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID ?? "qcwi8zepcl";

              let sessionID = getRecoil(claritySessionState);

              if (sessionID === null) {
                sessionID = v4();
                setRecoil(claritySessionState, sessionID);
              }

              Clarity.init(projectId);
              Clarity.identify(result.id, sessionID);
              Clarity.setTag("user_cpf", this.state.cpf);
              Clarity.setTag("user_id", result.id);
              Clarity.setTag("user_name", result.username);
              Clarity.setTag("session_id", sessionID);
              Clarity.upgrade("record all");
            }

            if (this.state.manterDados) {
              const date = new Date();
              date.setDate(date.getDate() + 3);
              await this.cookies.set('@SMO20/idResponsavel', result.id, {path: '/', expires: date});
              await this.cookies.set('@SMO20/nomeResponsavel', result.username, {path: '/', expires: date});
              await this.cookies.set('@SMO20/cpfResponsavel', this.state.cpf, {path: '/', expires: date});
              await this.cookies.set('@SMO20/senhaResponsavel', this.state.senha, {path: '/', expires: date});
            }

            inicializaUsuarioDD()

            this.setState({
              isLoaded: true,
              item: result,
            }, () => {
              const {history} = this.props;
              const searchParams = new URLSearchParams(window.location.search);
              const returnTo = searchParams.get('returnTo');
              const queryParams = new URLSearchParams({returnTo: returnTo});
              const queryString = queryParams.toString();
              returnTo ? history.push(`/inicio/?${queryString}`) : history.push('/inicio');
            });
          },
          () => {
            this.setState({
              isLoaded: true,
              error: "Login ou senha inválidos"
            });
          }
        )
        .catch(error => {
          console.error(error.message + " do catch 1");
        });
    } catch (error) {
      console.log("Ocorreu um erro contate o administrador: " + error);
    }
  }

  render() {
    if (this.state.redirecionar) {
      const {history} = this.props;
      history.push(PATH_ROUTE.INICIO);
    }
    return (
      <div className="home-container flex-column">
        <div className="App">
          <header className="App-header">
            <form className="form-acesso" onSubmit={this.btnclick}>
              <h1>Faça seu login </h1>

              <p>Preencha os campos abaixo para entrar no sistema</p>

              <div className="form-group">
                <label>CPF </label>
                <div className="">
                  <InputMask type="text"
                             className={"form-control " + formValidacao.cssCPF(this.state.errors["_cpf"], this.state.cpf)}
                             autoComplete="username"
                             mask="999.999.999-99" placeholder="000.000.000-00" id="cpf" value={this.state.cpf}
                             onKeyUp={event => console.log(event.currentTarget.value)}
                             name="cpf" onChange={event => this.change(event)}/>
                </div>
                <span style={{color: "red"}}>{this.state.errors["_cpf"]}</span>
              </div>
              <div className="form-group">
                <label>Senha</label>
                <div className="input-group">
                  <input type={this.state.type}
                         className={"form-control " + formValidacao.cssSenha(this.state.errors["_senha"], this.state.senha)}
                         autoComplete="current-password"
                         id="senha" value={this.state.senha} name="senha"
                         onChange={event => this.change(event)}/>
                  <button className="btn btn-outline-secondary" type="button" id="button-addon2"
                          onClick={(e) => this.HandleSenhaBtn(e)}><Eye/></button>
                </div>
                <span style={{color: "red"}}>{this.state.errors["_senha"]}</span>
              </div>


              <div className="custom-control custom-checkbox mb">
                <input className="custom-control-input" type="checkbox" checked={this.state.manterDados}
                       onChange={(e) => this.handleCheck(e)} id="lembrarDados"
                       name="lembrarDados"/>
                <label className="custom-control-label" htmlFor="lembrarDados">
                  Lembrar meus dados
                </label>
              </div>

              <Box
                sx={{
                  display: this.state.needChallenge ? "block" : "none",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 4,
                }}
              >
                <Box
                  component="div"
                  id="recaptcha"
                  sx={{
                    margin: "auto",
                  }}
                />
                <Box
                  component="span"
                  style={{color: "red"}}
                  sx={{
                    color: "red",
                  }}
                >
                  {this.state.errors["_captcha"]}
                </Box>
              </Box>

              <button
                className="medium btn-primary w-100"
                id="btnLogin"
                onClick={this.btnclick}
                disabled={!this.state.isLoaded}
              >
                {!this.state.isLoaded ? (
                  <img
                    src="/img/loading.gif"
                    width={20}
                    height={20}
                  />
                ) : "Entrar"}
              </button>
              <span style={{color: "red"}}>{this.state.error}</span>

              <div className="mt text-center">
                <Link
                  to="/RedefinirSenha"
                  className="btn-link"
                >
                  <span>Esqueci minha senha</span>
                </Link>
              </div>
            </form>
          </header>
        </div>

        <div className="home-version-container mt-4">
          <Version/>
        </div>
      </div>
    );
  }
}

export default withRouter(Home);